import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-icon-secondary hover:text-icon-hover cursor-pointer'
  }
});
